<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage trips</small>
      </legend>
      <div></div>
      <div>
        <div class="tripsLoader">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <i
            class="fa fa-spinner fa-spin"
            style="font-size: 24px; color: blue"
          ></i
          >loading trips...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemTrips"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'Interchange'">
              <span v-if="props.row.trip_status === 0">
                <button
                  type="submit"
                  class="btn btn-primary btn-sm btn-rounded tripId"
                  @click="viewTruckInterchange(props.row.id)"
                >
                  <i class="fa fa-plus"></i> Interchange
                </button>
              </span>
              <span v-else>
                <button
                  type="submit"
                  class="btn btn-success btn-sm btn-rounded"
                >
                  <i class="fa fa-check"></i> Completed
                </button>
              </span>
            </span>
            <span v-else-if="props.column.field === 'Expense'">
              <span v-if="props.row.trip_status === 0">
                <button
                  type="submit"
                  class="btn btn-primary btn-sm btn-rounded tripId"
                  @click="viewTrip(props.row.id)"
                >
                  <i class="fa fa-plus"></i> Add Expense
                </button>
              </span>
              <span v-else>
                <button
                  type="submit"
                  class="btn btn-success btn-sm btn-rounded"
                >
                  <i class="fa fa-check"></i> Completed
                </button>
              </span>
            </span>
            <span v-else-if="props.column.field === 'Payment'">
              <span v-if="props.row.payment_status === 0">
                <button
                  type="submit"
                  class="btn btn-primary btn-sm btn-rounded"
                  @click="loadPayments(props.row.id)"
                >
                  <i class="fa fa-money"></i> Add payment
                </button>
              </span>
              <span v-else-if="props.row.payment_status === 1">
                <button
                  type="submit"
                  class="btn btn-primary btn-sm btn-rounded"
                  @click="loadPayments(props.row.id)"
                >
                  <i class="fa fa-money"></i> Add payment
                </button></span
              >
              <span v-else-if="props.row.payment_status === 2">
                <button
                  class="btn btn-success btn-sm btn-rounded"
                  @click="loadPayments(props.row.id)"
                >
                  <i class="fa fa-check"></i> Full Paid
                </button></span
              >
            </span>
            <span v-else-if="props.column.field === 'Viewpayments'">
              <button
                type="submit"
                class="btn btn-primary btn-sm btn-rounded trip_id"
                @click="viewPayment(props.row.id)"
              >
                <i class="fa fa-plus"></i>
                print payments
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Trip no",
          field: "trip_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter trip number",
          },
        },
        {
          label: "Loading date",
          field: "loading_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, // outputs Mar 16th 2018
        },
        {
          label: "Container Expiry date",
          field: "container_expiry_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Container no",
          field: "container_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter container number",
          },
        },
        {
          label: "Truck no",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter truck number",
          },
        },
        {
          label: "Trailer no",
          field: "trailer_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter trailer number",
          },
        },
        {
          label: "Grand total",
          field: "grand_total",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Interchange",
          field: "Interchange",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Expense",
          field: "Expense",
          width: "100px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Payment",
          field: "Payment",
          width: "100px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Viewpayments",
          field: "Viewpayments",
          width: "100px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadTrips();
  },
  computed: {
    ...mapGetters(["systemTrips"]),
  },
  methods: {
    ...mapActions([
      "loadTrips",
      "viewTrip",
      "loadPayments",
      "viewPayment",
      "viewTruckInterchange",
    ]),
  },
};
</script>


// WEBPACK FOOTER //
// src/trips/managetrips.vue